export enum CertifyRole {
  // Administrator
  'ARK0005' = 0,
  // 'National'
  'ARK0006' = 1,
  // 'Regional'
  'ARK0007' = 2,
  // 'Technician'
  'ARK0008' = 3,
  // 'Read Only'
  'ARK0009' = 4,
  // 'Regional Limited Profile'
  'ARK0010' = 5,
  // 'Laboratorian'
  'ARK0011' = 6,
  // 'Internal Laboratorian'
  'ARK0012' = 7,
  // 'Batcher'
  'ARK0013' = 8,
}

export const ALLOWED_CERTIFY_ROLES: ReadonlyArray<CertifyRole> = [
  CertifyRole.ARK0006,
  CertifyRole.ARK0007,
  CertifyRole.ARK0010,
];

export const ALLOWED_CERTIFY_ROLE_CODES: ReadonlyArray<string> = ALLOWED_CERTIFY_ROLES.map((role) => CertifyRole[role]);
